import BaseExpansionPanel from "./BaseExpansionPanel.vue";

export default BaseExpansionPanel;
